import { fg } from '@atlassian/jira-feature-gating';

const EnableWorkItemForQuadraticReleaseRelayProvider = {
	get(): boolean {
		return fg('enable_work_item_for_quadratic_release');
	},
};

export default EnableWorkItemForQuadraticReleaseRelayProvider;
